import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trade-fail",
  "use": "icon-trade-fail-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-trade-fail\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 0H27V3H30V6H33V9H36V27H33V30H30V33H27V36H9V33H6V30H3V27H0V9H3V6H6V3H9V0ZM10.5754 12.6967L12.6968 10.5754L17.9999 15.8785L23.3031 10.5753L25.4245 12.6966L20.1212 17.9999L25.4247 23.3033L23.3034 25.4246L17.9999 20.1212L12.6965 25.4246L10.5752 23.3032L15.8786 17.9999L10.5754 12.6967Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol